/*
 * Copyright (c) 2024 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:mta-learning":true});}catch(e){}}();import { CaretDownIcon } from '@radix-ui/react-icons'
import * as Popover from '@radix-ui/react-popover'
import React from 'react'

import { cn } from '@/utils/css'

/** The properties for the mobile header top bar popover. */
type MobileHeaderTopBarTextPopoverProps = {
  /** The title of the popover. */
  title: string

  /** Accessible trigger name; defaults to an English expansion instruction. */
  ariaLabel?: string

  /** The content to display in the popover. */
  children: React.ReactNode
}

/**
 * The popover for the top bar of the mobile header. Exposes a trigger that displays the popover content when clicked.
 */
const MobileHeaderTopBarTextPopover: React.FC<MobileHeaderTopBarTextPopoverProps> = ({ title, ariaLabel, children }) => (
  <Popover.Root>
    <Popover.Trigger asChild>
      <button
        type={'button'}
        className={
          'group relative flex flex-row items-center gap-0.5 rounded-sm cursor-pointer hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-secondary-500 focus-visible:ring-offset-2 focus-visible:ring-offset-primary-500'
        }
        aria-label={ariaLabel ?? `Expand ${title}`}
      >
        {title}
        <CaretDownIcon
          aria-hidden={'true'}
          className={'relative top-px transition-transform duration-300 ease-in group-data-[state=open]:-rotate-180'}
        />
      </button>
    </Popover.Trigger>
    <Popover.Portal>
      <Popover.Content
        className={cn(
          'z-max shadow-lg rounded-bl-2xl rounded-br-2xl p-2 bg-primary-500 will-change-[transform,opacity] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-secondary-500',
          'data-[state=open]:data-[side=top]:animate-slide-down-and-fade data-[state=open]:data-[side=right]:animate-slide-left-and-fade data-[state=open]:data-[side=bottom]:animate-slide-up-and-fade data-[state=open]:data-[side=left]:animate-slide-right-and-fade',
        )}
        sideOffset={10}
      >
        {children}
      </Popover.Content>
    </Popover.Portal>
  </Popover.Root>
)

export { MobileHeaderTopBarTextPopover }
